import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { ActionLinkWrapper } from './styles';

type ActionLinkType = {
  size?: 'medium' | 'large';
  type?: 'email' | 'tel' | 'none';
  children: ReactNode;
} & ComponentPropsWithoutRef<'a'>;

const ACTION_LINK_TYPE_MAP = {
  email: 'mailto:',
  tel: 'tel:',
  none: '',
};

export const ActionLink = ({ size = 'medium', type = 'email', children, href, ...rest }: ActionLinkType) => {
  const linkType = ACTION_LINK_TYPE_MAP[type] || '';
  const linkHref = `${linkType}${href}`;

  return (
    <ActionLinkWrapper size={size} href={linkHref} {...rest}>
      {children}
    </ActionLinkWrapper>
  );
};
